import { extension, PlainExtension } from '@remirror/core';
import { dropCursor } from '@remirror/pm/dropcursor';

var _dec, _class;
var DropCursorExtension = (_dec = extension({
  defaultOptions: {
    color: 'black',
    width: 1
  }
}), _dec(_class = class DropCursorExtension extends PlainExtension {
  get name() {
    return 'dropCursor';
  }
  /**
   * Use the dropCursor plugin with provided options.
   */


  createExternalPlugins() {
    var _this$options = this.options,
        color = _this$options.color,
        width = _this$options.width;
    return [dropCursor({
      color,
      width
    })];
  }

}) || _class);

export { DropCursorExtension };
